<div
  class="file-upload-area"
  [ngClass]="{ 'file-over': hasFileOver() }"
  (click)="onFileClick()">
  <img class="upload-icon" src="assets/icons/upload.svg" />
  <div style="text-align: center">
    <span class="cal-text">{{ translationPrefix + 'cal' | translate }} </span>
    <span class="cal-text-shadow">{{
      translationPrefix + 'desc' | translate
    }}</span>
    <div class="cal-text-shadow">
      {{ translationPrefix + 'supported' | translate }}
    </div>
  </div>
  <input
    class="file-input"
    accept=".csv"
    type="file"
    #fileInput
    (change)="onFileChanged($event)" />
</div>

@if (file()) {
  <div class="file-area">
    <div class="file-area__content">
      <div class="file-area__content__name">
        <span class="small-heading">
          {{ file()?.name }}
        </span>
        <img
          class="cursor-pointer"
          (click)="deleteFile()"
          src="assets/icons/trash.svg" />
      </div>
      <div class="file-area__content__file-size">{{ fileSize() }}KB</div>
    </div>
  </div>
}

@if (hasError()) {
  <p-message
    severity="error"
    class="login-container__form__inner__err error-msg">
    <span>{{ translationPrefix + 'error.file-ext' | translate }}</span>
  </p-message>
}
